import {priority} from '@priority-software/priority-proto-api/lib';
import {isRTL} from '../../../../../../Localization';
import {formatDate} from '../../../../utils/date';

const dir = isRTL() ? 'rtl' : 'ltr';
const alignment = isRTL() ? 'right' : 'left';
const htmlDirectionAttributes = `dir="${dir}" style="direction:  ${dir}; text-align: ${alignment};"`;

export const prepareSignature = (
    data: priority.netitems.form.IHtmlSignatureBase | null,
    hrAtBeginning: boolean = false
) => {
    if (!data) return '';

    const {Email, Sincerely, Name, Hr, Position, Phone, Cellphone, Company, Branch} = data;

    const dateObj = new Date();
    const formatType = priority.netitems.form.ColumnType;
    const dateRow = formatDate(dateObj, formatType.Date14);

    let str = '';

    // Add HR at the beginning if requested
    if (Hr && hrAtBeginning) {
        str = str.concat(`<hr/>`);
    }

    str = str.concat(`<p ${htmlDirectionAttributes}>${dateRow}</p><p></p>`);

    if (Sincerely) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${Sincerely}</p>`);
    }

    str = str.concat(`<p ${htmlDirectionAttributes}>${Name}</p>`);

    if (Position) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${Position}</p>`);
    }

    if (Company) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${Company}</p>`);
    }

    str = str.concat('<p></p>');

    if (Branch) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${Branch}</p>`);
    }

    if (Email) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${Email}</p>`);
    }

    if (Phone) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${Phone}</p>`);
    }

    if (Cellphone) {
        str = str.concat(`<p ${htmlDirectionAttributes}>${Cellphone}</p>`);
    }

    // Add HR at the end if not at beginning
    if (Hr && !hrAtBeginning) {
        str = str.concat(`<p ${htmlDirectionAttributes}></p><hr/>`);
    }

    return str;
};
